<template>
        <BreadCrumb PageTitle=" Liste des factures" />
    <ListeFactureS/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";

 import ListeFactureS from "@/components/FactureS/ListeFactureS.vue";

    export default defineComponent({
      name: "ListeFactureSPage",
      components: {
        BreadCrumb,
        ListeFactureS,
      },
    });
  </script>